// Ενδεικτικές ισοτιμίες νομισμάτων — καθαρά πληροφοριακό, δεν επηρεάζει καμία
// πραγματική πληρωμή. Δωρεάν API χωρίς key (frankfurter.app, τιμές ΕΚΤ).
// Cache στη μνήμη της συνεδρίας για μερικές ώρες ώστε να μην καλείται συνέχεια.

type RatesCache = { fetchedAt: number; rates: Record<string, number> };

const CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 ώρες
const cache = new Map<string, RatesCache>();

/** Επιστρέφει πόσα EUR/USD ισοδυναμούν με 1 μονάδα του δοσμένου νομίσματος, ή null αν αποτύχει/είναι ήδη EUR&USD. */
export async function fetchConversion(fromCurrency: string): Promise<{ EUR: number; USD: number } | null> {
  if (fromCurrency === 'EUR') {
    // Ζητάμε μόνο USD.
  }
  const cached = cache.get(fromCurrency);
  if (cached && Date.now() - cached.fetchedAt < CACHE_TTL_MS) {
    return { EUR: cached.rates.EUR, USD: cached.rates.USD };
  }
  try {
    const res = await fetch(`https://api.frankfurter.app/latest?from=${encodeURIComponent(fromCurrency)}&to=EUR,USD`);
    if (!res.ok) return null;
    const json = (await res.json()) as { rates?: Record<string, number> };
    if (!json.rates) return null;
    const rates = { EUR: json.rates.EUR ?? (fromCurrency === 'EUR' ? 1 : NaN), USD: json.rates.USD ?? (fromCurrency === 'USD' ? 1 : NaN) };
    cache.set(fromCurrency, { fetchedAt: Date.now(), rates });
    return rates;
  } catch {
    return null;
  }
}
